import { Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FatalError } from '@cca/utils';
import { Nullable } from '@skylinecommunications/dwa-types';

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlingService {
    private readonly _router = inject(Router);
    private readonly _zone = inject(NgZone);

    public hasUnprocessedError = false;
    public encounteredError: Nullable<FatalError> = null;

    public fatalError(error: FatalError): void {
        if (this.hasUnprocessedError) return;

        this.hasUnprocessedError = true;
        this.encounteredError = error;

        this._zone.run(() => {
            this._router.navigateByUrl('/error', { skipLocationChange: true });
        });
    }
}
